module.exports = __webpack_public_path__ + "static/media/withdraw.37235b37.svg";